import { CapacityCategoryResource } from 'app/_resources/capacity-category.resource';
import { BalancingAndPortfolioUploadWizardService } from 'app/_services/balancing-and-portfolio-upload-wizard.service';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { BalancingGroupUploadWizardContext, mgoAngularWizard } from '../custom';

class BalancingGroupUploadWizardGeneralComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<BalancingGroupUploadWizardContext>;
    private originalBalancingGroupName: string;
    private errorPreparingNextWizardStage: boolean;
    private submitting: boolean;

    constructor(
        private $location: ng.ILocationService,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private capacityCategoryResource: CapacityCategoryResource,
        private balancingAndPortfolioUploadWizardService: BalancingAndPortfolioUploadWizardService,
        private capacityCategoryService,
        private StaticData
    ) {
        this.errorPreparingNextWizardStage = false;
        this.submitting = false;
    }

    $onInit(): void {
        if (this.wizardCtrl.context.currentBalancingGroup) {
            this.originalBalancingGroupName = angular.copy(
                this.wizardCtrl.context.currentBalancingGroup.name
            );
        }

        if (!this.wizardCtrl.context.allCapacityCategories) {
            this.loadShippersWithAssignmentToTso();
        }

        if (!this.wizardCtrl.context.shippersWithAssignmentToTso) {
            this.loadCapacityCategories();
        }
        if (!this.wizardCtrl.context.balancingGroupPatternDto) {
            this.loadBalancingGroupPatterns();
        }
    }

    private loadBalancingGroupPatterns() {
        this.StaticData.balancingGroupPattern(
            (res: BalancingGroupPatternDto) => {
                this.wizardCtrl.context.balancingGroupPatternDto = res;
            }
        );
    }

    private loadCapacityCategories() {
        this.capacityCategoryResource.get((res: CapacityCategory[]) => {
            let allCategoryValuesSorted = this.capacityCategoryService
                .translateCapacityCategories(res)
                .map((item) => item.value);
            this.wizardCtrl.context.allCapacityCategories =
                allCategoryValuesSorted;
            this.wizardCtrl.context.unselectedCapacityCategories = angular.copy(
                this.wizardCtrl.context.allCapacityCategories
            );
            this.wizardCtrl.context.selectedCapacityCategories = [];
        });
    }

    private loadShippersWithAssignmentToTso() {
        this.TransmissionSystemOperator.assignedShippers(
            (res: TsoShipperAssignmentsDto[]) => {
                this.wizardCtrl.context.shippersWithAssignmentToTso = res;
                this.wizardCtrl.context.unselectedShippers = angular.copy(res);
                this.wizardCtrl.context.selectedShippers = [];
            }
        );
    }

    public submit(isValid: boolean): boolean {
        if (!isValid) {
            return false;
        }

        this.submitting = true;

        this.balancingAndPortfolioUploadWizardService
            .prepareNextWizardStage(
                this.wizardCtrl.context.shippersWithAssignmentToTso,
                this.originalBalancingGroupName,
                this.wizardCtrl.context.currentBalancingGroup.name,
                'BALANCING'
            )
            .then((res: BalancingGroupAssignmentDto | undefined) => {
                if (res && res.name) {
                    this.wizardCtrl.context.currentBalancingGroup = res;
                    (
                        this.wizardCtrl.context.currentBalancingGroup as any
                    ).$$exists = true;
                } else {
                    (
                        this.wizardCtrl.context.currentBalancingGroup as any
                    ).$$exists = false;
                }

                this.wizardCtrl.next();
            })
            .catch(() => (this.errorPreparingNextWizardStage = true))
            .finally(() => (this.submitting = false));

        return true;
    }

    public cancel(): void {
        history.back();
    }
}

angular.module('app').component('pkpBalancingGroupUploadWizardGeneral', {
    controller: BalancingGroupUploadWizardGeneralComponentCtrl,
    template:
        require('app/balancing-group-upload-wizard/balancing-group-upload-wizard-general.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
